// frontend/src/pushNotifications.js
import authApiClient from './authApiClient';

// Function to get the VAPID public key from the server
const getVapidPublicKey = async () => {
  try {
    // Use only the path, authApiClient handles the base URL
    const response = await authApiClient.get('/push-subscription/public-key');
    return response.data.publicKey;
  } catch (error) {
    console.error('Error fetching VAPID public key:', error);
    throw error;
  }
};

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  const rawData = window.atob(base64);
  return new Uint8Array([...rawData].map(char => char.charCodeAt(0)));
}

export async function subscribeUserToPush() {
    // Add detailed logging
    console.log('[Push] entering subscribeUserToPush');

    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
      console.error('Push messaging is not supported in this browser');
      return null;
    }

    try {
      const vapidPublicKey = await getVapidPublicKey();
      // Log after getting key, before SW ready
      console.log('[Push] VAPID public key fetched. Waiting for service worker ready...');

      const registration = await navigator.serviceWorker.ready;          
      // Log after SW is ready
      console.log('[Push] service worker ready');

      // Check permission state & request if needed
      let permission = Notification.permission;
      if (permission === 'default') {
        console.log('[Push] Permission state is default. Requesting permission...');
        permission = await Notification.requestPermission(); // Request permission
        console.log('[Push] Permission request result:', permission);
      }

      if (permission !== 'granted') {
        // console.log('[Push] permission state:', Notification.permission, '(Needs to be granted)');
        console.log('[Push] Permission not granted (' + permission + '). Aborting subscription.');
        return null; 
      }
      // console.log('[Push] permission is granted'); // Redundant if check passed

      let subscription = await registration.pushManager.getSubscription();
      if (!subscription) {
        console.log('[Push] No existing subscription found. Creating new subscription...');
        subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
        });
        console.log('[Push] New subscription created successfully:', subscription);
      } else {
        console.log('[Push] Found existing subscription:', subscription);
        // IMPORTANT: Even if subscription exists, ensure it's saved to backend
        // Check if it exists in backend first
        try {
          const statusResponse = await authApiClient.get('/push-subscription');
          const hasBackendSubscription = statusResponse.data?.hasSubscription;
          
          if (!hasBackendSubscription) {
            console.log('[Push] ⚠️ Subscription exists in browser but not in backend - will save after getting subscription');
          } else {
            console.log('[Push] ✅ Subscription exists in both browser and backend');
          }
        } catch (statusError) {
          console.warn('[Push] Could not check backend subscription status:', statusError.message);
          // Continue - we'll try to save anyway
        }
      }

      // Log before sending to backend
      console.log('[Push] sending POST to /api/push-subscription with subscription:', subscription);
      try {
        const response = await authApiClient.post('/push-subscription', subscription); // Use subscription object directly
        console.log('[Push] POST to /api/push-subscription finished. Status:', response.status);
        console.log('[Push] Response:', response.data);
      } catch (error) {
        console.error('[Push] ERROR saving subscription to backend:', error);
        console.error('[Push] Error response:', error.response?.data);
        console.error('[Push] Error status:', error.response?.status);
        console.error('[Push] Error message:', error.message);
        // Don't return null - still return subscription even if save fails
      }
  
      return subscription;
    } catch (error) {
      console.error('[Push] Failed during subscribeUserToPush process:', error);
      return null;
    }
}
